(function () {
  'use strict';

  var SELECTOR = '[data-collection-split-scroll-hint]';
  var DEFAULT_STRENGTH = 32;

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function ScrollHint(list) {
    this.list = list;
    this.strength = parseInt(list.getAttribute('data-collection-split-scroll-hint'), 10) || DEFAULT_STRENGTH;
    this.frame = null;
    // Offset currently added by the page-scroll effect, and the visitor's own
    // scroll position it is measured from. Keeping them apart is what lets a
    // manual scroll take over without the hint snapping back to the top.
    this.offset = this.targetOffset();
    this.anchor = list.scrollTop - this.offset;

    this.onPageScroll = this.schedule.bind(this);
    this.onListScroll = this.rebase.bind(this);
    this.onFrame = this.apply.bind(this);

    window.addEventListener('scroll', this.onPageScroll, { passive: true });
    window.addEventListener('resize', this.onPageScroll, { passive: true });
    list.addEventListener('scroll', this.onListScroll, { passive: true });
  }

  ScrollHint.prototype.maxScroll = function () {
    return Math.max(0, this.list.scrollHeight - this.list.clientHeight);
  };

  ScrollHint.prototype.targetOffset = function () {
    var rect = this.list.getBoundingClientRect();
    var viewport = window.innerHeight || document.documentElement.clientHeight;
    var travel = viewport + rect.height;
    if (travel <= 0) return 0;
    var progress = clamp((viewport - rect.top) / travel, 0, 1);
    return Math.round(progress * this.strength);
  };

  ScrollHint.prototype.schedule = function () {
    if (this.frame) return;
    this.frame = window.requestAnimationFrame(this.onFrame);
  };

  ScrollHint.prototype.apply = function () {
    this.frame = null;
    var max = this.maxScroll();
    if (max <= 1) return;

    var offset = this.targetOffset();
    if (offset === this.offset) return;
    this.offset = offset;
    this.list.scrollTop = clamp(this.anchor + offset, 0, max);
  };

  ScrollHint.prototype.rebase = function () {
    var expected = clamp(this.anchor + this.offset, 0, this.maxScroll());
    if (Math.abs(this.list.scrollTop - expected) <= 1) return;
    this.anchor = this.list.scrollTop - this.offset;
  };

  ScrollHint.prototype.destroy = function () {
    if (this.frame) window.cancelAnimationFrame(this.frame);
    window.removeEventListener('scroll', this.onPageScroll);
    window.removeEventListener('resize', this.onPageScroll);
    this.list.removeEventListener('scroll', this.onListScroll);
    this.list.removeAttribute('data-scroll-hint-ready');
  };

  var instances = [];

  function init(list) {
    if (!list || list.getAttribute('data-scroll-hint-ready') === 'true') return;
    if (prefersReducedMotion()) return;
    list.setAttribute('data-scroll-hint-ready', 'true');
    instances.push(new ScrollHint(list));
  }

  function drop(matches) {
    instances = instances.filter(function (instance) {
      if (!matches(instance.list)) return true;
      instance.destroy();
      return false;
    });
  }

  function initAll(root) {
    drop(function (list) {
      return !list.isConnected;
    });
    (root || document).querySelectorAll(SELECTOR).forEach(init);
  }

  function teardown(root) {
    drop(function (list) {
      return root.contains(list);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target) return;
    teardown(event.target);
  });
})();
